import { Box, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField, Typography } from "@mui/material"
import { ListResult } from "../components/IndexView/IndexResult"
import { useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { useAppDispatch, useAppSelector } from "../lib/hook";
import { fetchSearch, IndexRequest, indexSelector } from "../lib/ducks/indexDuck";

const SourcesTables = [
    { "names": ["perinto_secret"], "displayName": "perinto_secret" }
];

const IndexView = () => {
    const isLoading = useAppSelector(indexSelector).isLoading;
    const isInitial = useAppSelector(indexSelector).initial;

    const dispatch = useAppDispatch()
    const [selectedIndex, setSelectedIndex] = useState<string>("");

    const handleChange = (event: SelectChangeEvent<string>) => {
        const selectedValue = event.target.value;
        setSelectedIndex(selectedValue);
        
        // Get the actual index name from SourcesTables
        const indexName = SourcesTables[Number(selectedValue)]?.names[0] || "";
        
        const body: IndexRequest = { index_name: indexName, skip: 0 }
        dispatch(fetchSearch(body))
    };

    return (
        <Box
            display="flex"
            //justifyContent="center"
            flexDirection={'column'}
            alignSelf={'center'}
            minHeight={'407px'}
            sx={{ width: { xs: "100vw", sm: "1011px" }, backgroundColor: '#FCFCFC', borderStyle: 'solid', border: 1, borderRadius: '8px', borderColor: '#E6E6E9' }}
            padding={'32px'}
            maxHeight={'90%'}
        >
            {isInitial &&
                <>
                    <Typography align="center" fontSize={'18px'} fontWeight={600} margin={2}>
                        Näytä indexoidut dokumentit
                    </Typography>
                    <Typography align="center" fontSize={'16px'} fontWeight={400} margin={2} marginTop={0}>
                        
                    </Typography>
                </>
            }
            <Box
                maxWidth={'300px'}
                marginBottom={4}
            >
                <Typography fontSize={'16px'} fontWeight={'fontWeightBold'} marginY={2}>
                    Indexit
                </Typography>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Valitse indexi</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedIndex}
                        label="Valitse lähde"
                        onChange={handleChange}
                    >
                        {SourcesTables.map((source, index) => (
                            <MenuItem key={"sourceitem" + index} value={index}>{source.displayName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            {isLoading &&
                <CircularProgress sx={{ marginTop: 2, alignSelf: 'center' }} />
            }

            {!isInitial &&
                <ListResult />
            }

        </Box>
    )
}
export default IndexView;